module.exports = __webpack_public_path__ + "img/clipboard.6226893c.svg";